import moment from "moment";

export default function (doc, filters, { ticketBlocksMap } = {}) {
  const filtersList = [];

  // Courtesy
  if (filters.courtesy === false || filters.hideCourtesy) filtersList.push("Não inclui cortesias");

  // Dates
  if (filters.dates || filters.startDate || filters.endDate) {
    const [startDate, endDate] = filters.dates || [filters.startDate, filters.endDate];
    if (moment(startDate).isSame(endDate, "day"))
      filtersList.push(
        `Vendas do dia ${moment(startDate).format("DD/MM/YYYY")}`
      );
    else
      filtersList.push(
        `Vendas entre ${moment(startDate).format("DD/MM/YYYY")} e ${moment(
          endDate
        ).format("DD/MM/YYYY")}`
      );
  }

  // sellers
  if (filters.sellers && filters.sellers.length > 0) {
    filtersList.push(
      `${filters.sellers.length} vendedor${filters.sellers.length > 1 ? "es" : ""
      }`
    );
  }

  // ticketBlocks
  if (filters.ticketBlocks && filters.ticketBlocks.length > 0) {
    if (!ticketBlocksMap || ticketBlocksMap.size !== filters.ticketBlocks.length) {
      filtersList.push(
        `${filters.ticketBlocks.length} lote${filters.ticketBlocks.length > 1 ? "s" : ""
        }`
      );
    }
  }

  // channels
  if (filters.channel && filters.channel.length > 0 && filters.channel.length !== 3) {
    if (filters.channel.length === 1) filtersList.push(`Canal: Apenas ${filters.channel[0]}`);
    else filtersList.push(`Canais: ${filters.channel.join(", ")}`);
  }

  // Add filters to document
  if (filtersList.length === 0) {
    doc.addText(`Nenhum filtro aplicado`, 11, { spacing: 6 });
  } else {
    const filterText = filtersList.join(" — ");
    doc.addText(`Filtros: ${filterText}`, 11, { spacing: 6 });
  }
  return;
}
